<template>
    <div class="history mg-sm-15">
        <div class="" v-for="history in histories">
            <HistoryItemComponent :history="history"/>
        </div>
    </div>
</template>

<script>
    import HistoryItemComponent from "./HistoryItemComponent";
    export default {
        mounted() {
        },
        props: ['histories'],
        components: {
            HistoryItemComponent
        }
    }
</script>
